module.exports = __webpack_public_path__ + "static/img/1.f9c4674.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/3/sp/1.png
// module id = gwdJ
// module chunks = 0